import { MapperBase } from '../../utilities/mapper-base';
import { ProcessingActiveStepResource } from '../resource/processing-active-step.resource';
import { ProcessingStep } from '../ui/processing-step.model';
import { DateUtility } from '../../utilities/date.utility';

export class ProcessingActiveStepResourceToProcessingStepMapper extends MapperBase<ProcessingActiveStepResource, ProcessingStep> {
	map(source: ProcessingActiveStepResource): ProcessingStep {
		const dest = new ProcessingStep();
		dest.id = source.id;
		dest.stepId = source.stepId;
		dest.documentId = source.docId;
		dest.caseName = source.caseName;
		dest.functionName = source.functionName;
		dest.createdDateTime = DateUtility.toLocal(source.createdDateTime);
		dest.serverIpAddress = source.serverIp;
		return dest;
	}
}

